declare var jQuery:any;
declare var productLocalize:any;

export class Ajax {
    admin_url: string;
    nonce: string;
    data: any;

    constructor(ajax_url:any = null, nonce:any = null) {
        this.admin_url = ajax_url ?? productLocalize.ajax_url;
        this.nonce = nonce ?? productLocalize.nonce;
        this.data = {
            nonce: this.nonce
        };
    }
    public setData(key:string, value:any):void {
        this.data[key] = value;
    }

    public getData(key:string):any {
        if (key in this.data) {
            return this.data[key];
        }
        return null;
    }

    public restartData() {
        this.data = {
            nonce: this.nonce
        };
    }

    public jAjax(url:string, type:string, dataType:string, data:any, onSuccess:any, onError:any, onComplete:any) {
        let ajaxArgs:any = {
            type : type,
            dataType : dataType,
            url : url,
            success: onSuccess,
            error: onError,
            complete: onComplete
        }
        if (data) {
            ajaxArgs['data'] = data;
        }
        jQuery.ajax(ajaxArgs);
    }

    public callWPAjax(action:string, onSuccess:any=null, onError:any=null, method:string='post', onComplete:any=null) {
        this.data['action'] = action;
        if (!onSuccess) {
            onSuccess = (resp:any) => {console.log(resp)}
        }
        if (!onError) {
            onError = (err:any) => {console.error(err)}
        }
        if (!onComplete) {
            onComplete = (resp:any) => {}
        }
        this.jAjax(
            this.admin_url,
            method,
            "json",
            this.data,
            onSuccess,
            onError,
            onComplete
        )
    }

    public async callWPAjaxAsync(action:string, method:string='post'): Promise<any> {
        this.data['action'] = action;
        return new Promise((resolve, reject) => {
            this.jAjax(
                this.admin_url,
                method,
                "json",
                this.data,
                (resp:any) => resolve(resp),
                (err:any) => reject(err),
                (resp:any) => {}
            )
        });
    }
}
